import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-dashboard-loading-card',
  templateUrl: './dashboard-loading-card.component.html',
  styleUrls: ['./dashboard-loading-card.component.scss']
})
export class DashboardLoadingCardComponent implements OnInit {

  @Input() title;
  @Input() bigger;

  constructor() { }

  ngOnInit() {
  }

}
